export default __webpack_public_path__ + "static/media/dolphin-world.c7e0984f.jpeg";